import React from "react";
import { EuiPage, EuiPageBody } from "@elastic/eui";
import { HardwareInventoryPanel } from "./inventory";

export * from "./inventory";
export * from "./useHardwareInventory";

/**
 * `opsanio > Hardware` - the fleet-wide NetBox hardware inventory.
 *
 * Its own side-nav section rather than a panel on the appliance dashboard: the
 * pool it shows is fleet-wide (every server, switch and DAC cable autonubil
 * owns, assigned or spare), not scoped to one appliance. Gated on
 * `opsanio/hardware · view` - both here in the route table and again on
 * `GET /api/v2/netbox/inventory`, which is the actual boundary.
 */
export const OpsanioHardwarePage = (): JSX.Element => (
  <EuiPage>
    <EuiPageBody>
      <HardwareInventoryPanel />
    </EuiPageBody>
  </EuiPage>
);

export default OpsanioHardwarePage;
